<template>
    <div>
        <vue-select
            :options="paymentMethods"
            label="name"
            multiple
            v-model="selectedPaymentMethods"
            class="rounded-8 bg-transparent"
            disabled
        ></vue-select>
        <!-- <option v-for="method, index in paymentMethods" :value="method.id" :key="index" :selected="isSelected(method.id)">{{ method.name }}</option> -->
        <payment-method-amount
            :orderTotal="orderTotal"
            :payment-methods="selectedPaymentMethods"
            :amounts="amounts"
            class="rounded-8"
        ></payment-method-amount>
    </div>
</template>

<script>
import PaymentMethodAmount from './PaymentMethodAmount.vue'
import 'vue-select/dist/vue-select.css'

export default {
    components: { PaymentMethodAmount },
    props: ['orderId', 'paymentMethods', 'orderInvoices', 'changePaymentMethodsRoute', 'orderTotal'],
    data: () => ({
        selectedPaymentMethods: [],
        amounts: [],
        customDiscount: 0,
    }),
    mounted() {
        for (const invoice of this.orderInvoices) {
            if (!invoice.custom_discount) {
                if (invoice.serie) {
                    // TODO
                }

                if (invoice.treatment) {
                    // TODO
                }
                if (!invoice.serie && !invoice.treatment) {
                    var paymentMethod = invoice.payment_method
                    this.selectedPaymentMethods.push(paymentMethod)
                    this.amounts.push({
                        paymentMethod: paymentMethod.id,
                        amount: invoice.amount,
                        name: paymentMethod.name,
                        idInvoice: invoice.id,
                    })
                }
            }
        }
    },
    methods: {
        isSelected(id) {
            for (const order of this.orderInvoices) {
                if (order.payment_method_id == id) {
                    return true
                }
            }
        },
        deleteAllInput() {
            this.$emit('deleteAllInput')
        },
    },
}
</script>
